import {CompetitionViewModel} from "../../../domain/common/competition/models/competition-view-model";
import {CompetitorCompetitionsDomainModel} from "../../../domain/common/competitor/models/competitor-competitions.domain-model";
import {computed, observable} from "mobx";
import {CompetitorStandingsWidgetTerms} from "../competitor-standings-widget.terms";

export class CompetitorStandingsCompetitionViewModel extends CompetitionViewModel {
  @observable terms: CompetitorStandingsWidgetTerms;

  constructor(model: CompetitorCompetitionsDomainModel, isSelected: Boolean, terms: CompetitorStandingsWidgetTerms) {
    super(model);

    this.domainModel = model;
    this.isSelected = isSelected;
    this.terms = terms;
  }

  get linkModel() {
    return null;
  }

  @computed get name() {
    const selectedTitle: String = `${this.domainModel.name} - ${this.standingsDescription}`;
    const standingsLabel: String = this.isSelected ? selectedTitle : this.domainModel.name;

    return standingsLabel;
  }

  @computed get standingsDescription() {
    const standingsDescription: String = this.hasStandingsGroups ? this.terms.GROUP_TABLES : this.terms.STANDINGS;

    return standingsDescription;
  }
}
